module.exports = __webpack_public_path__ + "img/pc-help-6.af72ee1d.jpg";